export const AppKey = "Amp";

/**
 * Used to constrain the list of features that can be enabled/disabled.
 * These values must match the Feature Key values in ABAC DB based on
 * the format `{AppKey}:{FeatureName}` where FeatureName is the value
 */
export const AppFeatures = [
  // Add new feature keys here so they are added to the AppFeature type
  "FeaturesEnabledIcon",
  //   "MyExampleFeature",
] as const;

export type AppFeature = typeof AppFeatures[number];

/**
 * Used to look up a feature by name. Values must match the AppFeature type.
 */
export const AppFeatureLookup: Record<string, AppFeature> = {
  FeaturesEnabledIcon: "FeaturesEnabledIcon",
  // MyExampleFeature: "MyExampleFeature",
};
